<template>
    <div class="header">
        <x-header
            color="primary"
            :isMenuOpen="menuOpen"
            :back-button="showBackButton"
            @menuTriggerClick="menuOpen = !menuOpen"
            @backButtonClick="backButton"
        >
            <template v-slot:middle>
                <router-link :to="dashboardLink" class="logo">
                    <span>xTrade Casualty</span>

                    <img src="/assets/img/from-howden.svg">
                </router-link>
            </template>

            <template v-slot:right>
                <x-btn v-if="$root.usingAdvancedActivitiesFramework()" flat ><my-tasks-icon/></x-btn>
            </template>
        </x-header>

        <navigation-overlay :menuOpen="menuOpen" @closeNav="closeNav"/>
    </div>
</template>

<script>
    import NotificationsMixin from '~/mixins/notifications';
    import MyTasksIcon from "../UIComponents/Tasks/MyTasksIcon";
    import NavigationOverlay from '~/components/Shared/Partials/NavigationOverlay';

    export default {
        name: 'NavBar',
        components: {
            MyTasksIcon,
            NavigationOverlay
        },
        mixins: [NotificationsMixin],
        props: ['info', 'notifications'],
        data: function () {
            return {
                user: [],
                menuOpen: false
            }
        },
        computed: {
            dashboardLink() {
                return this.$root.userIsInsurer ? '/insurer/dashboard/' : '/agent/dashboard/';
            },
            showBackButton() {
                return !['broker-dashboard', 'insurer-dashboard'].includes(this.$route.name);
            },
            logo() {
                return `/assets/img/${this.$root.application.theme.name}-logo.svg`
            }
        },
        methods: {
            closeNav() {
                this.menuOpen = false;
            },
            backButton() {
                this.closeNav();

                this.$router.go(-1);
            }
        },
    }
</script>
<style lang="scss" scoped>
.header {
    .x-header {
        position: sticky;
        top: 0;
        z-index: 5;

        :deep(.container) {
            padding: 0 1%;
        }

        :deep(.x-header__middle) {
            height: 100%;
            padding: 10px 15px;

            a {
                height: 32px;
            }
        }
    }

    :deep(.x-header__middle) {
        height: 100%;
        padding: 10px 15px;
    }
    .logo {
        font-size: rem(32px);
        font-weight: 600;
        line-height: 1em;
        text-decoration: none;
        color: $color-white;
        height: 100%;
        display: flex;
        align-items: center;
        span {
            margin-right: 12px;
            color: $color-pistachio;
        }
    }

    :deep(.x-header__middle) {
        height: 100%;
        padding: 10px 15px;
    }
    .logo {
        font-size: rem(32px);
        font-weight: 600;
        line-height: 1em;
        text-decoration: none;
        color: $color-white;
        height: 100%;
        display: flex;
        align-items: center;
        span {
            margin-right: 12px;
            color: $color-pistachio;
        }
    }
}
</style>
